module.exports = __webpack_public_path__ + "static/media/logout-icon-active.f9bf1c29.svg";